
import { defineComponent } from "vue";
import api, { SheqsyArchiveList, SheqsyArchive, RequestPaging, PageBounding, RequestSort }  from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: SheqsyArchiveList;
  requestFilter: SheqsyArchive;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
  filterOptions: Record<string, unknown>;
}

export default defineComponent({
  name: "ReceiverEventArchive",
  mounted() {
    this.$nextTick(() => {
      this.processQueryParams();
      this.getList();
    });
  },

  data: (): State => {
    const archive_list = { count: 0 } as SheqsyArchiveList;
    const archive_struct = { } as SheqsyArchive;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    const filter_options = {};
    return {
      msg: "Sheqsy Archives",
      backendResponse: archive_list,
      requestFilter: archive_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      filterOptions: filter_options,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    getHumanDate,
    processQueryParams() {
      if ('f.EmployeeUId' in this.$route.query && typeof(this.$route.query['f.EmployeeUId']) == 'string') {
        this.requestFilter.EmployeeUId = this.$route.query['f.EmployeeUId']
      }
      if ('f.ActivityUId' in this.$route.query && typeof(this.$route.query['f.ActivityUId']) == 'string') {
        this.requestFilter.ActivityUId = this.$route.query['f.ActivityUId']
      }
    },
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as SheqsyArchive;
      this.requestFilter = filter_struct;
      this.getList()
    },
    getDownload(id: string) {
      api.getSheqsyArchive(id).then(response => {
        const blob = new Blob([JSON.stringify(response.data)], { type: 'text/json' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'SheqsyActivityArchive-' + id + '.json'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    deleteArchive(id: string) {
      api.deleteSheqsyArchive(id).then(() => {
        this.$router.go(0)
      });
    },
    getList() {
      this.backendResponse.items = [];
      this.$router.push({query: {'f.EmployeeUId': this.requestFilter.EmployeeUId, 'f.ActivityUId': this.requestFilter.ActivityUId}})
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getSheqsyArchiveList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
